function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.97 10.224c-.871 0-1.726-.136-2.536-.404-.397-.135-.885-.01-1.127.238l-1.6 1.207c-1.854-.99-2.997-2.132-3.973-3.972l1.172-1.558a1.15 1.15 0 00.282-1.165 8.087 8.087 0 01-.405-2.54C5.783 1.4 5.27.89 4.642.89H2.03C1.4.889.889 1.4.889 2.03c0 7.213 5.868 13.081 13.08 13.081.63 0 1.142-.512 1.142-1.141v-2.605c0-.629-.512-1.14-1.141-1.14z",
  fill: "#B5BFCD"
});

var SvgCall = function SvgCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref);
};

export default SvgCall;